import { h, FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import * as styles from '~src/styles/domains/initial/InitialPage.module.scss';
import Loading from '../common/components/Loading';
import ProcessingView from '../common/components/ProcessingView';
import { OrderLoadStatus, Page } from '../common/enums/api';
import { Locale } from '../common/enums/localization';
import {
  orderLoadStatusSelector,
  pageSelector,
} from '../common/state/commonSelectors';

const InitialPage: FunctionComponent = () => {
  const orderLoadStatus = useSelector(orderLoadStatusSelector);
  const page = useSelector(pageSelector);
  const failedOrder = orderLoadStatus === OrderLoadStatus.FAILED;
  // For invalid offers, get locale from browser / system OS
  const isLoadingInitialPage =
    (orderLoadStatus === OrderLoadStatus.NOT_STARTED ||
      orderLoadStatus === OrderLoadStatus.LOADING) &&
    page == Page.INITIAL;
  const browserLanguages = (navigator.languages || []) as Locale[];
  const showErrorFrCa =
    browserLanguages.includes(Locale.frCA) ||
    browserLanguages.includes(Locale.enCA);

  return isLoadingInitialPage ? (
    <ProcessingView />
  ) : (
    <div className={styles['initial-wrapper']}>
      {failedOrder ? (
        <div className={styles['initial-alert']} data-testid='initial-error'>
          <div className={styles['initial-error-msg']}>
            There was an error loading your offer. Your link may have expired.
            Please contact your agent and have them generate a new offer.
          </div>
          {showErrorFrCa && (
            <div className={styles['initial-error-msg']}>
              Une erreur s'est produite lors du chargement de votre offre. Votre
              lien a peut-être expiré. Veuillez svp contacter votre agent pour
              générer une nouvelle offre.
            </div>
          )}
        </div>
      ) : (
        <Loading classLabel={styles['initial-loading']} />
      )}
    </div>
  );
};

export default InitialPage;
